import { render, staticRenderFns } from "./UseSwitch.vue?vue&type=template&id=0435e48e&scoped=true&lang=pug"
import script from "./UseSwitch.vue?vue&type=script&lang=ts"
export * from "./UseSwitch.vue?vue&type=script&lang=ts"
import style0 from "./UseSwitch.vue?vue&type=style&index=0&id=0435e48e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0435e48e",
  null
  
)

export default component.exports